import React from 'react';
import { useAudioPlayer } from './AudioPlayerProvider';

export const PlayText = () => {
    const { played, playing } = useAudioPlayer();

    let contentText = 'Play now';

    if (playing) {
        contentText = 'Playing now';
    }

    if (played === 1) {
        contentText = 'Played';
    }

    return (
        <div
            className="player-text"
            style={{
                display: 'flex',
                width: '94px',
                alignItems: 'center',
                paddingRight: '16px',
                color: 'white',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '18px',
                justifyContent: 'end',
                letterspacing: '-0.4px',
            }}
        >
            {contentText}
        </div>
    );
};
